<template>    
    <v-dialog
      v-model="dialog"
      width="500"      
    >      
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
            Resumen
          <v-btn icon @click="deleteDocument">
            <v-icon>mdi-trash-can-outline</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-layout wrap align-center>            
            <v-flex xs10 offset-xs1 mb-3>
              <TimeTable/>
            </v-flex>      
            <v-flex xs10 offset-xs1 mb-3>
              <v-file-input
                multiple
                dense
                prepend-icon="mdi-camera"
                v-model="images"
                @change="test"
              ></v-file-input>
            </v-flex>
            <v-flex xs10 offset-xs1 mb-3>
              <SignaturePad/>
            </v-flex>
            <br>          
            <v-flex xs8 offset-xs2 mb-5>
              <v-btn block color="warning" dark @click="openCustomerSignatureDialog">Firma Cliente</v-btn>
            </v-flex>               
            <v-flex xs8 offset-xs2 mb-5>
              <v-btn block color="success" dark @click="createDocument">Finalizar</v-btn>
            </v-flex>               
        </v-layout>                        
        <v-divider></v-divider>       
      </v-card>
    </v-dialog>  
</template>
<script>
import TimeTable from '@/components/TimeTable.vue'
import SignaturePad from '@/components/SignaturePad.vue'
export default {
    name: 'dialogSignature',
    components:{
      TimeTable,
      SignaturePad
    },
    data () {
      return {        
      }
    },
    methods:{
        test(){
          console.log(this.images);
        },
        close(){
            this.dialog = false;                        
        },
        closeOK(){            
            this.dialog = false;                        
        },                
        openCustomerSignatureDialog(){
          this.$store.state.dialogSignatureCustomer = true;
        },
        deleteDocument(){
          this.$store.commit('resetDataAfterSuccessfulCreation');
        }
    },
    mounted(){
      
    }, 
    watch:{      
    },
    computed:{
        dialog: {
            get(){
                return this.$store.state.dialogSignature;
            },
            set(value){
                this.$store.state.dialogSignature = value;
            }
        },
        proyectos:{
            get(){
                return this.$store.state.jobs;
            }
        },
        tareas:{
            get(){
                return this.$store.state.jobTasks;
            }
        },
        proyecto:{
            get(){
                return this.$store.state.proyecto;                
            }/*,
            set(value){
                this.$store.state.proyecto = value;
            }*/
        },
        proyectoFullName:{
            get(){
                var jobno = this.$store.state.proyecto;
                var fullname = '';
                if (jobno != ''){
                  var res = this.$store.state.proyectos.find(job =>{
                    return job.no == jobno;
                  });
                  console.log(res);
                }
                return fullname;
            }
        },
        tarea:{
            get(){
                return this.$store.state.tarea;
            }/*,
            set(value){
                this.$store.state.tarea = value;
            }*/
        },
        images:{
            get(){
                return this.$store.state.images;
            },
            set(value){
                this.$store.state.images = value;
            }
        }
    }
}
</script>

